import PropTypes from 'prop-types';
import React from 'react';

import './InsurancesCarousel.scss';

export function ImagesCarousel({ images }) {
  return (
    <div className="carousel-container">
      <div className="carousel-fade" />
      <div className="carousel-images">
        {images.map((image) => (
          <div className="carousel-image" key={image}>
            <img
              src={image}
              alt="insurance"
              className="image"
              key={image}
            />
          </div>
        ))}
      </div>

      <div aria-hidden className="carousel-images">
        {images.map((image) => (
          <div className="carousel-image" key={image}>
            <img
              src={image}
              alt="insurance"
              className="image"
              key={image}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

ImagesCarousel.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export function InsurancesCarousel() {
  const images = [
    '/img/insurances/aetna.png',
    '/img/insurances/blue_california.png',
    '/img/insurances/united_healthcare.png',
    '/img/insurances/medicare.png',
    '/img/insurances/anthem.png',
    '/img/insurances/cigna.png',
    '/img/insurances/healthnet.png',
  ];

  return <ImagesCarousel images={images} />;
}

export function PressCarousel() {
  const images = [
    '/img/press/fortune.png',
    '/img/press/fierce_healthcare.png',
    '/img/press/medcity_news.png',
    '/img/press/new_york_post.png',
    '/img/press/toms_guide.png',
    '/img/press/sleep_review.png',
  ];

  return <ImagesCarousel images={images} />;
}
